import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  block-size: 100%;
  inline-size: 100%;
`;

export const ContainerSingleMode = styled.div`
  display: grid;
  block-size: 100%;
  inline-size: 100%;
  grid-template-columns: 1fr 1fr;
`;

export const FiltersContainerBuffon = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: repeat(2, auto);
  grid-template-areas:
    "fornecedor regiao lojas"
    ". produto subgrupo ";
  justify-content: end;
  align-items: center;
  gap: 1rem;
  block-size: 100%;
  inline-size: 100%;

  div.menu-select-wrapper div.textfield-outer div.textfield-wrapper {
    block-size: 20px !important;
    inline-size: 200px !important;
  }

  div.textfield-outer div.ragnarok.textfield-wrapper button {
    margin-top: 12px !important;
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  inline-size: 100%;
  block-size: auto;
`;

export const OuterContainerBuffon = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.3rem;
  inline-size: 100%;
  block-size: 100%;

  div.menu-select-wrapper div.textfield-outer div.textfield-wrapper {
    border: 0.0625rem solid rgba(17, 24, 39, 0.125);
  }
`;